import type {GetListResponse, ParamsOptions} from "@/src/modules/core/types";

import {darsApi} from "../api";
import type {DailyActivityReport} from "../types";

class DarsService {
  async getDars(options: ParamsOptions): Promise<GetListResponse<DailyActivityReport>> {
    const {data} = await darsApi.search(options);
    const raw = data as {data?: unknown; daily_activity_reports?: unknown[]};
    const items = Array.isArray(raw.data)
      ? raw.data
      : Array.isArray(raw.daily_activity_reports)
        ? raw.daily_activity_reports
        : (raw.data as {data?: unknown[]})?.data ?? [];
    const meta = (data as {meta?: {total: number; from?: number; to?: number}}).meta ?? {total: 0};
    return {
      data: items as DailyActivityReport[],
      meta: {
        total: meta.total,
        from: meta.from ?? 0,
        to: meta.to ?? 0,
      },
    };
  }

  async getDar(id: number): Promise<DailyActivityReport | undefined> {
    const {data} = await darsApi.getById(id);
    return data.data;
  }

  async createDar(payload: Record<string, unknown>): Promise<DailyActivityReport | undefined> {
    const {data} = await darsApi.create(payload);
    return data.data;
  }

  async updateDar(
    id: number,
    payload: Record<string, unknown>,
  ): Promise<DailyActivityReport | undefined> {
    const {data} = await darsApi.update(id, payload);
    return data.data;
  }

  async deleteDar(id: number): Promise<void> {
    await darsApi.delete(id);
  }

  async getDarCodes(): Promise<{daily_activity_report_code_id: number; type: string}[]> {
    const {data} = await darsApi.getDarCodes();
    return data.daily_activity_report_codes ?? [];
  }

  async getDarTypes(): Promise<{daily_activity_report_type_id: number; type: string}[]> {
    const {data} = await darsApi.getDarTypes();
    return data.daily_activity_report_types ?? [];
  }
}

export const darsService = new DarsService();
